<template>
  <div v-if="seamless.length > 0">
    <div class="section-title">
      <i class="fas fa-dice"></i>
      Lotto <label>(** ต้องไม่รับโบนัส **)</label>
    </div>
    <div
      v-for="(slot, index) in seamless"
      :index="index"
      :key="index"
      class="contaniner-seamless"
    >
      <img :src="slot.background" @click="goToSeamless(slot.code)" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import apiSeamless from '@/api/seamless'

export default {
  name: 'CarouselAccount',
  props: {
    type: {
      type: String, // NOTE : 'slotAccount' || 'sportAccount' || 'lottoAccount'
      default: 'slotAccount'
    },
    modalSlot: Function
  },
  computed: {
    ...mapState({
      seamless: store => store.userInfo.seamless
    })
  },
  updated() {
    if (this.$refs.treeExplorer)
      this.$refs.treeExplorer.goSlide(this.$refs.treeExplorer.currentIndex)
  },
  methods: {
    async goToSeamless(code) {
      try {
        const response = await apiSeamless.launch(code)
        if (response) {
          const a = document.createElement('a')
          a.setAttribute('href', response.link)
          a.setAttribute('target', '_blank')
          a.click()
          document.body.appendChild(a)
        }
      } catch {
        // silently ignore — timeline just won't show
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.section-title {
  i {
    color: $text-color;
  }
}
.contaniner-seamless {
  // width: 80%;
  text-align: center;

  img {
    max-width: 85%;
    height: auto;

    &:hover {
      cursor: pointer;
      opacity: 0.9;
    }
  }
}
</style>
